import axios from "axios";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";

export async function fetchInvoices(startDate, endDate, token, signal) {
    try {
        const response = await axios.post(
            "/api/invoices",
            { startDate, endDate },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                signal,
            }
        );

        return response.data;
    } catch (e) {
        if (axios.isCancel(e) || e.name === 'CanceledError') return;
        console.log('Error', e);
        throw e;
    }
}

export async function fetchInvoices2({
    startDate,
    endDate,
    token,
    invNumber = '',
    invTypes = [],
    invCreatedDates = [],
    invDueDates = [],
    invStatuses = [],
    invPaymentStatuses = [],
    userIds = [],
    tz,
    page = 1,
    limit = 10,
    sortBy = null,
    sortDirection = 'desc',
    signal,
}) {
    try {
        const response = await axios.post(
            "/api/invoices-optimized",
            {
                startDate,
                endDate,
                invNumber,
                invTypes,
                invCreatedDates,
                invDueDates,
                invStatuses,
                invPaymentStatuses,
                userIds,
                tz,
                page,
                limit,
                sortBy,
                sortDirection,
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                signal,
            }
        );

        return response.data;
    } catch (error) {
        if (axios.isCancel(error) || error.name === 'CanceledError') return;
        console.error("Error fetching invoices:", error.message);
        throw error;
    }
}

export function useFetchInvoices({
    startDate,
    endDate,
    token,
    invNumber,
    invTypes,
    invCreatedDates,
    invDueDates,
    invStatuses,
    invPaymentStatuses,
    userIds,
    tz,
    page,
    limit,
    sortBy,
    sortDirection,
}) {
    return useQuery(
        [
            "invoices",
            token,
            startDate,
            endDate,
            invNumber,
            invTypes,
            invCreatedDates,
            invDueDates,
            invStatuses,
            invPaymentStatuses,
            userIds,
            tz,
            page,
            limit,
            sortBy,
            sortDirection,
        ],
        ({ signal }) =>
            fetchInvoices2({
                startDate,
                endDate,
                token,
                invNumber,
                invTypes,
                invCreatedDates,
                invDueDates,
                invStatuses,
                invPaymentStatuses,
                userIds,
                tz,
                page,
                limit,
                sortBy,
                sortDirection,
                signal,
            }),
        {
            staleTime: 5 * 60 * 1000,
            cacheTime: 10 * 60 * 1000,
            keepPreviousData: true,
            refetchOnMount: true,
            refetchOnWindowFocus: false,
            onError: (error) => {
                console.error("Error fetching invoices:", error);
            },
        }
    );
}  